import {Loader} from "rsuite";

const Content = (props) => {
    const { children, isLoading, className, loaderSize } = props;
    return isLoading ?
        <div className={"page-content with-loader " + className} > <Loader size={loaderSize} center /></div> :
        <div className={'page-content ' + className}>{children}</div>
}

Content.defaultProps = {
    className: '',
    isLoading: false,
    loaderSize: 'lg'
}


export default Content;